import ControllerWarpper from "@/components/common/ControllerWarpper"
import Text from "@/components/common/Typography/Text"
import Title from "@/components/common/Typography/Title"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { useTERouter } from "@/hooks/app/useTERouter"
import { useAirlines } from "@/hooks/flight/useAirlines"
import { useTour } from "@/hooks/tour/useTour"
import { useTourPrice } from "@/hooks/tour/useTourPrice"
import { bookingActions } from "@/lib/redux/features/booking/reduce"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { thunks } from "@/lib/redux/thunks"
import { getCustomerCode } from "@/utils/booking/getCustomerCode"
import { track } from "@/lib/tracking"

import { validatePhoneNumber } from "@/utils/validates/validatePhoneNumber"
import { yupResolver } from "@hookform/resolvers/yup"
import { Button, Col, Divider, Form, Image, Input, Row, theme } from "antd"
import dayjs from "dayjs"
import { FC, useMemo } from "react"
import { useForm } from "react-hook-form"
import { toast } from "react-toastify"
import * as yup from 'yup'
import { EMAIL_REGEX } from "@/utils/validates/validateEmail"
import TourFlight from "./TourFlight"
import { useTETranslation } from "@/hooks/app/useTETranslation"
import { useTranslation } from "react-i18next"

const schema = yup.object({
  fullName: yup.string().required("booking.fullname_input_required_message"),
  phoneNumber: yup.string()
    .required("booking.phonenumber_input_required_message")
    .test(
      "contact.phone",
      "booking.phonenumber_input_rule_message",
      validatePhoneNumber
    ),
  email: yup.string().trim().matches(EMAIL_REGEX, { message: "booking.email_input_rule_message", excludeEmptyString: true }),
  note: yup.string(),
}).required()

type FormRequestBookingTourProps = {
  onSuccess: () => void
  onCancel: () => void
}

const FormRequestBookingTour: FC<FormRequestBookingTourProps> = (props) => {
  const { getFormatCurrency, getValidDayjs } = useTETranslation()
  const { totalAmount } = useTourPrice()
  const form = useForm({
    resolver: yupResolver(schema)
  })
  const inputTour = useAppSelector(state => state.tour.inputTour)
  const { tour: { data: tour } } = useTour()
  const selectedDepartureSchedule = useAppSelector(state => state.tour.inputTour.selectedDepartureSchedule)
  const { t } = useTranslation()

  const isDesktop = useIsDesktop()
  const departureSchedule = useMemo(() => {
    const departureSchedule = tour?.departureSchedule?.find(d => d.id === selectedDepartureSchedule)
    return departureSchedule
  }, [selectedDepartureSchedule, tour?.departureSchedule])

  const flights = departureSchedule?.flights || []

  const dispatch = useAppDispatch()

  const handleSubmit = ({ note, ...values }: any) => {

    const itinData = {
      tour: {
        ...tour,
        departureSchedule: [departureSchedule],
      },
      input: {
        ...inputTour,
        ...values,
        note
      }
    }

    dispatch(thunks.flight_create_order({
      body: {
        TYPE: 'JSON',
        partnerId: process.env.NEXT_PUBLIC_AUTHEN_API_CLIENT_ID,
        customerCode: getCustomerCode({ phone: values.phoneNumber }),
        orderDate: dayjs().format("YYYY-MM-DD"),
        productType: "TOUR",
        totalAmount: totalAmount,
        discountAmount: 0,
        serviceAmount: 0,
        feeAmount: 0,
        services: [],
        payWithPoint: 50,
        voucherCode: "",
        isInvoice: false, // !!export_bill,
        metaData: '[]',
        itinData: JSON.stringify(itinData),
        // ...(export_bill ? {
        //   invoice: {
        //     ...invoice,
        //     amount: totalAmount
        //   }
        // } : {})
        // source: `Đặt vé máy bay (Hãng ${flights.map(f => f.segments.map(seg => seg.airline).join(', ')).join(', ')}), Chuyến${isRoundAway ? ' khứ hồi' : ''} từ ${firstSeg?.startPoint} đến ${lastSeg?.endPoint}, thời gian đi: ${getValidDayjs(firstSeg?.startTime).format("DD/MM/YYYY")}${isRoundAway ? `, thời gian về: ${getValidDayjs(lastSeg?.startTime).format("DD/MM/YYYY")}` : ''}`
      }
    })).unwrap().then(async (res) => {
      // DOP-925: tour_booking_start — gửi yêu cầu đặt tour thành công (modal tour detail)
      track('tour_booking_start', {
        order_id: res?.data?.orderCode,
        tour_id: `${tour?.id || ''}`,
        amount: totalAmount,
      })

      await dispatch(thunks.customer_temp({
        body: {
          TYPE: 'JSON',
          title: `TOUR BOOKING - ĐƠN HÀNG ${res?.data?.orderCode}`,
          fullName: values.fullName,
          phoneNumber: values.phoneNumber,
          note: note,
          source: "tour"
        }
      })).unwrap()

      dispatch(bookingActions.gotoBookingResult())
      toast.success(t("booking.send_request_booking_tour_successful"))
      props.onSuccess()
    }).catch(() => {
      toast.error(t("booking.send_request_booking_tour_failure"))
    })
  }

  return (
    <>
      <Row>
        <Title level={3} style={{ marginBlock: 0 }}>
          {t("booking.pass_info")}
        </Title>
      </Row>
      <Row style={{ marginBottom: "1rem" }}>
        <Text type='secondary'>
          {t("booking.pass_info_tour_desc")}
        </Text>
      </Row>
      <Form
        layout='vertical'
      >
        <Row gutter={15}>
          <Col xs={24} md={12}>
            <ControllerWarpper
              name="fullName"
              label={t("common.fullname")}
              required
              control={form.control}
              render={({ field }) => {
                return (
                  <Input {...field} />
                )
              }}
            />
          </Col>
          <Col xs={24} md={12}>
            <ControllerWarpper
              name="phoneNumber"
              label={t("common.phonenumber")}
              required
              control={form.control}
              render={({ field }) => {
                return (
                  <Input {...field} />
                )
              }}
            />
          </Col>
        </Row>

        <Row justify='start'>
          <Title level={3} style={{ marginTop: 0 }}>
            {t("booking.tour_info")}
          </Title>
        </Row>

        <Row wrap={!isDesktop} gutter={[15, 10]} justify='start'>
          <Col flex={"25rem"}>
            <Image
              preview={false}
              style={{ borderRadius: 8 }}
              src={(tour.images || [])[0]?.path}
            />
          </Col>
          <Col flex={1}>
            <Row>
              <Title style={{ margin: 0 }} level={4}>
                {tour?.name}
              </Title>
            </Row>
            <Row>
              <Col span={isDesktop ? undefined : 24}>
                <Row>
                  <Text style={{ marginRight: 10 }}>{t("tour.departure_date")}:</Text>{' '}<Text strong>{getValidDayjs(departureSchedule?.startDate).format("DD-MM-YYYY")}</Text>
                </Row>
                <Row>
                  <Text style={{ marginRight: 10 }}>{t("tour.tour_code")}:</Text> <Text strong>{' '}{tour?.tourId}</Text>
                </Row>
              </Col>
              {isDesktop && (<Divider orientation='vertical' style={{ height: '12rem' }} />)}
              <Col span={isDesktop ? undefined : 24}>
                <Row>
                  <Text style={{ marginRight: 10 }}>{t("tour.number_of_slot")}:</Text><Text strong>{inputTour.inputAdt + inputTour.inputChd1 + inputTour.inputChd2 + inputTour.inputInf}</Text>
                </Row>
                <Row>
                  <Text style={{ marginRight: 10 }}>{t("common.adult")}:</Text><Text strong>{inputTour.inputAdt}</Text>
                </Row>
                <Row>
                  <Text style={{ marginRight: 10 }}>{t("common.child")} 1:</Text><Text strong>{inputTour.inputChd1}</Text>
                </Row>
                {!!tour.agesChildren2From && tour.agesChildren2To && (
                  <Row>
                    <Text style={{ marginRight: 10 }}>{t("common.child")} 2:</Text><Text strong>{inputTour.inputChd2}</Text>
                  </Row>
                )}
                <Row>
                  <Text style={{ marginRight: 10 }}>{t("common.infant")}:</Text><Text strong>{inputTour.inputInf}</Text>
                </Row>
              </Col>
            </Row>
            <Divider style={{ marginBlock: '1rem' }} />
            <Row justify='start'>
              <Title level={4} style={{ marginTop: 0 }}>
                {t("tour.flight_info")}
              </Title>
              {/* <Text strong>Thông tin chuyến bay</Text> */}
            </Row>
            <Row gutter={15}>
              {flights.map((segments, idx) => {
                return (
                  <Col xs={24} md={12}>
                    <TourFlight segments={segments} index={idx} />
                  </Col>
                )
              })}

            </Row>
            <Row justify='start'>
              <Text strong>{t("tour.total_price")}: <Text style={{ fontSize: '2rem' }} strong type='danger'>{getFormatCurrency(totalAmount)}</Text></Text>
            </Row>
          </Col>
        </Row>


        <Row justify='center' style={{ marginTop: '1rem' }} gutter={15}>
          <Col span={isDesktop ? undefined : 12}>
            <Button
              style={{ minWidth: "15rem" }}
              size='large'
              onClick={props.onCancel}
              block
            >
              {t("common.cancel")}
            </Button>
          </Col>
          <Col span={isDesktop ? undefined : 12}>
            <Button
              block
              style={{ minWidth: "15rem" }}
              size='large'
              type='primary'
              onClick={form.handleSubmit(handleSubmit)}
            >
              {t("booking.submit_request")}
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  )
}

export default FormRequestBookingTour